import React from "react";

import Tooltip from "platopulse/components/Tooltip";
import NightModeIcon from "platopulse/components/icons/NightModeIcon";
import FullscreenIcon from "platopulse/components/icons/FullscreenIcon";
import RefreshWidget from "platopulse/dashboard/components/RefreshWidget";

export const getDashboardActions = (
    {
        isEditing = false,
        isEmpty = false,
        isFullscreen,
        isNightMode,
        onNightModeChange,
        onFullscreenChange,
        refreshPeriod,
        refreshElapsed,
        onRefreshPeriodChange
    }
) => {
    const buttons = [];

    if (!isEditing && !isEmpty) {
        buttons.push(
            <RefreshWidget
                data-platopulse-event="Dashboard;Refresh Menu Open"
                className="text-brand-hover"
                key="refresh"
                period={refreshPeriod}
                elapsed={refreshElapsed}
                onChangePeriod={onRefreshPeriodChange}
            />
        );
    }

    if (!isEditing && isFullscreen) {
        buttons.push(
            <Tooltip tooltip={isNightMode ? "Daytime mode" : "Nighttime mode"}>
                <span
                    data-platopulse-event={"Dashboard;Night Mode;" + !isNightMode}
                >
                    <NightModeIcon
                        className="text-brand-hover cursor-pointer"
                        key="night"
                        isNightMode={isNightMode}
                        onClick={() => onNightModeChange(!isNightMode)}
                    />
                </span>
            </Tooltip>
        );
    }

    if (!isEditing && !isEmpty) {
        // option click to enter fullscreen without making the browser go fullscreen
        buttons.push(
            <Tooltip
                tooltip={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
            >
                <span
                    data-platopulse-event={
                        "Dashboard;Fullscreen Mode;" + !isFullscreen
                    }
                >
                    <FullscreenIcon
                        className="text-brand-hover cursor-pointer"
                        key="fullscreen"
                        isFullscreen={isFullscreen}
                        onClick={e =>
                            onFullscreenChange(!isFullscreen, !e.altKey)}
                    />
                </span>
            </Tooltip>
        );
    }

    return buttons;
};



// WEBPACK FOOTER //
// ./dashboard/components/DashboardActions.jsx